import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NbThemeModule, NbActionsModule, NbLayoutModule, NbMenuModule, NbSidebarModule, NbUserModule, NbButtonModule, NbIconModule, NbToggleModule, NbBadgeModule, NbSelectModule, NbAutocompleteModule } from "@nebular/theme";
import { HeaderComponent, SidebarComponent } from "./layout";
import { ValidationStatusDirective, ValidationSummaryComponent } from "./validation";
import { TagsInputComponent } from "./forms";
import { NotDefinedWhenNullPipe, SlashWhenNullPipe, DateBasicPipe, SlashWhenNullOrZeroPipe } from "./pipes";
import { NotFoundComponent } from "./404/not-found.component";
import { WeightValueComponent, ScoreValueComponent, ReportValueComponent, HeightValueComponent, TrDataComponent, PercentileValueComponent } from "./elements";
import { DiameterMeasurementComponent } from "./elements/diameter-measurement/diameter-measurement.component";
import { HelperService } from "./helpers";
import { ErrorHandlerService } from "./errors/services/error-handler.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { HttpErrorInterceptor } from "./errors/error-interceptor.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ModalComponent } from "./modal/components/modal/modal.component";
import { ModalService } from "./modal/components/services/modal.service";
import { AttachFileComponent } from './attach-file/attach-file.component';
import { DropFilesDirective } from './attach-file/drop-files.directive';
import { MedicoFechaComponent } from './medico-fecha/medico-fecha.component';
import { AppFormThemeModule, AppThemeModule } from "../app-theme.module";
import { ConfirmDialogComponent } from "./modal/components/modal-confirmacion/modal-confirmacion.component";
import { ModalWarningComponent } from "./modal/components/modal-warning/modal-warning.component";
import { GaugeComponent } from "./components/gauge/gauge.component";
import { LimitCounterComponent } from "./components/limit-counter/limitCounter.component";

@NgModule({
  providers: [
    HelperService,
    ErrorHandlerService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    ModalService,
  ],
  imports: [
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NbThemeModule,
    NbActionsModule,
    NbLayoutModule,
    NbMenuModule,
    NbSidebarModule,
    NbUserModule,
    NbButtonModule,
    NbIconModule,
    NbToggleModule,
    NbBadgeModule,
    NbSelectModule,
    AppThemeModule,
    AppFormThemeModule,
    NbAutocompleteModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HeaderComponent,
    SidebarComponent,
    TagsInputComponent,
    ValidationStatusDirective,
    ValidationSummaryComponent,
    NotDefinedWhenNullPipe,
    SlashWhenNullPipe,
    DateBasicPipe,
    SlashWhenNullOrZeroPipe,
    ScoreValueComponent,
    WeightValueComponent,
    ReportValueComponent,
    HeightValueComponent,
    TrDataComponent,
    DiameterMeasurementComponent,
    PercentileValueComponent,
    AttachFileComponent,
    MedicoFechaComponent,
    ConfirmDialogComponent,
    ModalWarningComponent,
    GaugeComponent,
    LimitCounterComponent
  ],
  declarations: [
    HeaderComponent,
    SidebarComponent,
    TagsInputComponent,
    ValidationStatusDirective,
    ValidationSummaryComponent,
    NotFoundComponent,
    NotDefinedWhenNullPipe,
    SlashWhenNullPipe,
    DateBasicPipe,
    SlashWhenNullOrZeroPipe,
    ScoreValueComponent,
    WeightValueComponent,
    ReportValueComponent,
    HeightValueComponent,
    TrDataComponent,
    DiameterMeasurementComponent,
    PercentileValueComponent,
    ModalComponent,
    AttachFileComponent,
    MedicoFechaComponent,
    DropFilesDirective,
    ConfirmDialogComponent,
    GaugeComponent,
    LimitCounterComponent,
    ModalWarningComponent],
  entryComponents: [ModalComponent, ConfirmDialogComponent, ModalWarningComponent],
})
export class SharedModule { }
